import React from 'react'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'

import styles from './styles.module.scss'

export default function HistoryTree({ treeType, expData }) {
  const { t } = useTranslation()
  const institutionProp = treeType === 'education' ? 'institution' : 'organization'
  const roleProp = treeType === 'education' ? 'degree' : 'role'

  return (
    <div className={`${styles.experiencesWrap}`}>
      {expData &&
        expData.map((e, index) => (
          <div key={index} className={`${styles.experiences}`}>
            <div className={`${styles.year}`}>
              {dayjs(e.start_date).format('MMM YYYY')}
              {' - '}
              {e.end_date ? dayjs(e.end_date).format('MMM YYYY') : t('global.current')}
            </div>
            <div className={`${styles.company}`}>
              <div className={`${styles.companyDetails}`}>
                <h2 className={`${styles.role}`}>{e[roleProp]}</h2>
                <h2 className={`${styles.companyName}`}>{e[institutionProp]}</h2>
              </div>
            </div>
          </div>
        ))}
    </div>
  )
}
